import { render, staticRenderFns } from "./DiplomaIndex.vue?vue&type=template&id=84fea346"
import script from "./DiplomaIndex.vue?vue&type=script&lang=js"
export * from "./DiplomaIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports